import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../root-route";
import { HomePage } from "./home";
import { ProchesPage } from "./proches-page";
import { QuestionsPage } from "./questions-page";
import { SettingsPage } from "./settings-page";
import { SharedPage } from "./shared-page";

/**
 * Routes de l'app. Fichier possede par l'app : le template ne le reecrit pas (_skip_if_exists).
 *
 * `/` montre la connexion ou la frise selon la session (spec, section 1). `/questions` tire une
 * question a la fois (ticket 5). `/proches` invite, retire et valide les propositions (ticket 7) ;
 * un proche n'y entre pas (403 `owner_only`), sa vue est celle de `/`.
 */
export const homeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: () => <HomePage />,
});

export const settingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/reglages",
  component: SettingsPage,
});

export const questionsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/questions",
  component: QuestionsPage,
});

export const closeOnesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/proches",
  component: ProchesPage,
});

/**
 * La frise d'un lien de partage (#588) : publique, sans connexion, en lecture seule. Le jeton est
 * dans l'adresse ; la page ne l'affiche jamais et le serveur ne le garde pas en clair.
 */
export const sharedRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/v/$token",
  component: () => <SharedPage />,
});

export const appRoutes = [homeRoute, settingsRoute, questionsRoute, closeOnesRoute, sharedRoute];
